import { useEffect, useMemo, useState } from 'react';
import BoutiqueClubMarquageCanvas from './BoutiqueClubMarquageCanvas';
import { FACES_PERSONNALISATION } from './boutiqueClubPersonnalisationUtils';

const labels = { AVANT:'DEVANT', ARRIERE:'DOS', COTE_GAUCHE:'CÔTÉ G.', COTE_DROIT:'CÔTÉ D.', AUTRE:'AUTRE' };

export default function BoutiqueClubPersonnalisationViewer({
  className = '', article, visuels = [], marquages = [], options = [], valeurs = {}, urlsPhotos = {}, polices = [],
  fallbackImage = '', imageAlt = 'Article personnalisé', afficherNavigation = true
}) {
  const disponibles = useMemo(() => {
    const actifs = visuels.filter((v) => v.actif !== false);
    const resultat = actifs.map((v) => ({
      ...v,
      // Une vue de personnalisation ne doit jamais masquer le produit. Si sa
      // photo dédiée manque encore, la photo catalogue reste visible derrière
      // les calques de la face concernée.
      _image:v.url || urlsPhotos[v.storage_path] || fallbackImage
    }));
    if (fallbackImage && !actifs.some((v) => v.face === 'AVANT')) {
      resultat.unshift({
        id:`catalogue-avant-${article?.id || 'article'}`,
        face:'AVANT',
        libelle:'Vue catalogue',
        ordre:-1,
        actif:true,
        _image:fallbackImage
      });
    }
    return resultat.filter((v) => v._image).sort((a,b) => Number(a.ordre || 0) - Number(b.ordre || 0));
  }, [article?.id, visuels, urlsPhotos, fallbackImage]);
  const defaut = disponibles.find((v) => v.face === 'AVANT')?.id || disponibles[0]?.id || '';
  const [visuelId,setVisuelId] = useState(defaut);
  useEffect(() => { if (!disponibles.some((v) => v.id === visuelId)) setVisuelId(defaut); }, [defaut, disponibles, visuelId]);
  const visuel = disponibles.find((v) => v.id === visuelId) || disponibles[0];
  if (!visuel) return fallbackImage ? <img src={fallbackImage} alt={imageAlt} loading="lazy" decoding="async"/> : null;
  return <div className="bc-personnalisation-viewer" data-article-id={article?.id || ''}>
    {afficherNavigation && disponibles.length > 1 && <nav className="bc-personnalisation-views" aria-label="Vues du produit">
      {disponibles.map((v) => <button key={v.id} type="button" aria-pressed={v.id === visuel.id} onClick={() => setVisuelId(v.id)}>
        {labels[v.face] || FACES_PERSONNALISATION.find(([id]) => id === v.face)?.[1]?.toUpperCase() || v.face}
      </button>)}
    </nav>}
    <BoutiqueClubMarquageCanvas className={className} image={visuel._image} imageAlt={`${imageAlt} — ${labels[visuel.face] || visuel.face}`}
      visuel={visuel} marquages={marquages} options={options} valeurs={valeurs} urlsPhotos={urlsPhotos} polices={polices}
      fallbackImage={fallbackImage}/>
  </div>;
}
